import { useEffect, useState } from "react";

import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import type { CheckBoxFieldProps } from "@/ui/core/CheckBoxField";
import CheckBoxField from "@/ui/core/CheckBoxField";

const StoryMeta: Meta<CheckBoxFieldProps> = {
  title: "Core/Check Box Field",
  component: CheckBoxField,
  argTypes: {
    isDisabled: { control: "boolean" },
    leftText: { control: "text" },
    onChange: { action: "Changed" },
    rightText: { control: "text" },
    subLabel: { control: "text" },
  },
  args: {
    isDisabled: false,
    leftText: faker.lorem.words(2),
    rightText: "",
    subLabel: "",
  },

  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render(args) {
    const [isChecked, setIsChecked] = useState<boolean | undefined>(
      args.isChecked,
    );

    useEffect(() => {
      setIsChecked(args.isChecked);
    }, [args.isChecked]);

    return (
      <CheckBoxField
        {...args}
        isChecked={isChecked}
        onChange={(isCheckedValue) => {
          setIsChecked(isCheckedValue);
          args.onChange(isCheckedValue);
        }}
      />
    );
  },
};

type Story = StoryObj<CheckBoxFieldProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
